import axios from 'axios';
import jwt_decode from 'jwt-decode';

axios.defaults.baseURL = process.env.REACT_APP_SERVER_DOMAIN;

// Attach JWT to every axios request if present
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** Make API Requests */

/** To get email from Token */
export function getEmailFromToken() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Cannot find token in localStorage");

  const decoded = jwt_decode(token);
  if (!decoded?.email) throw new Error("Token does not contain an email field");

  return decoded.email;
}

/** authenticate function */
export async function authenticate(email){
  try {
    return await axios.post('/api/authenticate', { email });
  } catch (error) {
    return { error: "Email doesn't exist...!" };
  }
}

/** get User details */
export async function getEmail ({ email }) {
  try {
    const { data } = await axios.get(`/api/user/${email}`);
    return { data };
  } catch (error) {
    return { error: "User not found...!" };
  }
}

export async function registerUser(credentials) {
  try {
    const response = await axios.post('/api/register', credentials);
    const { msg } = response.data;
    const { status } = response;
    const { email, firstName } = credentials;  // assuming your registration form collects firstName

    if (status === 201) {
      // Send a friendly welcome email with firstName, subject and personalized text
      await axios.post('/api/registerMail', {
        firstName,                  // to use in email greeting
        userEmail: email,           // recipient email
        text: `Welcome to First Response Therapy, ${firstName}! We're excited to have you with us.`,  // email intro text
        subject: "Welcome to First Response Therapy!"
      });
    }

    return Promise.resolve(msg);
  } catch (error) {
    const errorMsg =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Something went wrong during registration.";

    console.error("User registration failed:", errorMsg);
    return Promise.reject({ error: errorMsg });
  }
}

/** login function */
export async function verifyPassword({ email, password }){
  try {
    if(email){
      const { data } = await axios.post('/api/login', { email, password })
      return Promise.resolve({ data });
    }
  } catch (error) {
    return Promise.reject({ error : "Password doesn't Match...!"})
  }
}

/** update user profile function */
export async function updateUser(response){
  try {
    const token = await localStorage.getItem('token');
    const data = await axios.put('/api/updateuser', response, { headers : { "Authorization" : `Bearer ${token}`}});

    return Promise.resolve({ data })
  } catch (error) {
    return Promise.reject({ error : "Couldn't Update Profile...!"})
  }
}

/** generate OTP */
export async function generateOTP(email){
  try {
    const { data: { code }, status } = await axios.get('/api/generateOTP', { params: { email } });

    // send mail with the OTP
    if(status === 201){
      const { data: userData } = await getEmail({ email });
      const text = `Your one-time password is ${code}. Reset it now.`;
      await axios.post('/api/registerMail', {
        email,
        userEmail: userData.email,
        text,
        subject: "Password Recovery OTP"
      });
    }

    return Promise.resolve(code);
  } catch (error) {
    return Promise.reject({ error });
  }
}

/** verify OTP */
export async function verifyOTP({ email, code }){
  try {
    const { data, status } = await axios.get('/api/verifyOTP', { params : { email, code }})
    return { data, status }
  } catch (error) {
    return Promise.reject(error);
  }
}

/** reset password */
export async function resetPassword({ email, password }){
  try {
    const { data, status } = await axios.put('/api/resetPassword', { email, password });
    return Promise.resolve({ data, status})
  } catch (error) {
    return Promise.reject({ error })
  }
}
